'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ProductDiscountPercent = exports.ProductDiscount = exports.BaseProduct = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _dec, _class2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _apiProduct = require('../../actions/esdb/apiProduct');

var _translate = require('@esnpm/translate');

var _reactBootstrap = require('react-bootstrap');

var _nodeToolbox = require('@esnpm/node-toolbox');

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseProduct = exports.BaseProduct = (_temp = _class = function (_React$Component) {
	_inherits(BaseProduct, _React$Component);

	function BaseProduct(props) {
		_classCallCheck(this, BaseProduct);

		var _this = _possibleConstructorReturn(this, (BaseProduct.__proto__ || Object.getPrototypeOf(BaseProduct)).call(this, props));

		_this.state = {
			initialized: false
		};
		_this.isComponentMounted = false;
		return _this;
	}

	_createClass(BaseProduct, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.isComponentMounted = true;
			this.loadProduct();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState, snapshot) {
			if (prevProps.SKU != this.props.SKU) {
				this.loadProduct();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.isComponentMounted = false;
		}
	}, {
		key: 'loadProduct',
		value: function loadProduct() {
			var _this2 = this;

			this.props.dispatch((0, _nodeToolbox.action_once)(function (state) {
				return _this2.shouldProductBeenLoaded(state);
			}, (0, _apiProduct.apiProduct)({ SKU: this.props.SKU }))).then(function () {
				if (_this2.isComponentMounted) {
					_this2.productLoaded();
				}
			});
		}
	}, {
		key: 'shouldProductBeenLoaded',
		value: function shouldProductBeenLoaded(state) {
			if (state.products[this.props.SKU] == null) return true;
			if (state.products[this.props.SKU].data == null) return true;
			return false;
		}
	}, {
		key: 'getDiscountRate',
		value: function getDiscountRate() {
			var product = this.props.products[this.props.SKU].data;
			var sellingPlatform = product.SELLING_PLATFORMS.filter(function (sp) {
				return sp.SELLING_PLATFORM === 'WEBSHOP';
			})[0];
			var price = sellingPlatform.SALE.PRICES.filter(function (price) {
				return price.AMOUNT === 1;
			})[0];

			var discount = 0;

			if (price.BRUTTO_SP !== price.ORIGINAL_BRUTTO_SP) discount = Math.round(100 - 100 / price.ORIGINAL_BRUTTO_SP * price.BRUTTO_SP);

			return discount;
		}
	}, {
		key: 'loadProductData',
		value: function loadProductData() {
			var product = this.props.products[this.props.SKU].data;
			var sellingPlatform = product.SELLING_PLATFORMS.filter(function (sp) {
				return sp.SELLING_PLATFORM === 'WEBSHOP';
			})[0];

			var productData = {
				SKU: product.SKU,
				NAME_TEXT_PATH: 'products.' + product.SKU + '.NAME_TEXT',
				SHORT_TEXT_PATH: 'products.' + product.SKU + '.SHORT_TEXT',
				LONG_TEXT_PATH: 'products.' + product.SKU + '.LONG_TEXT',
				PRODUCT_PATH: '/product/' + product.SKU,
				MAINPICTURE: product.ASSETS.filter(function (mp) {
					return mp.ASSET_TYPE === 'PRODUCT_MAIN_PICTURE';
				})[0],
				SP: sellingPlatform,
				PRICE: sellingPlatform.SALE.PRICES.filter(function (p) {
					return p.AMOUNT === 1;
				})[0],
				MOQ: sellingPlatform.SALE.MINIMUM_ORDER_QUANTITY,
				MANUFACTURER_SKU: product.MANUFACTURER.MANUFACTURER_SKU,
				MANUFACTURER_NAME: product.MANUFACTURER.MANUFACTURER_NAME,
				DISCOUNT_RATE: this.getDiscountRate()
			};

			return productData;
		}
		//wird unter anderem vom Singleproduct überschireben und setzt zum beispiel noch die sidecategory

	}, {
		key: 'productLoaded',
		value: function productLoaded() {
			this.setState({ initialized: true });
		}
	}, {
		key: 'dataLoaded',
		value: function dataLoaded() {
			if (!this.isComponentMounted) return false;
			if (!this.state.initialized) return false;
			if (this.props.products[this.props.SKU] === undefined) return false;
			if (this.props.products[this.props.SKU].data === undefined) return false;
			if (this.props.products[this.props.SKU].loading === undefined) return false;
			if (this.props.products[this.props.SKU].loading) return false;
			return true;
		}
	}]);

	return BaseProduct;
}(_react2.default.Component), _class.propTypes = {
	SKU: _propTypes2.default.any.isRequired
}, _temp);
var ProductDiscount = exports.ProductDiscount = (_dec = (0, _reactRedux.connect)(function (state) {
	return {
		products: state.products
	};
}), _dec(_class2 = function (_React$Component2) {
	_inherits(ProductDiscount, _React$Component2);

	function ProductDiscount(props) {
		_classCallCheck(this, ProductDiscount);

		return _possibleConstructorReturn(this, (ProductDiscount.__proto__ || Object.getPrototypeOf(ProductDiscount)).call(this, props));
	}

	_createClass(ProductDiscount, [{
		key: 'getDiscount',
		value: function getDiscount() {
			var product = this.props.products[this.props.SKU].data;
			var discount = product.SURCHARGE_DISCOUNT_COST.filter(function (sdc) {
				return sdc.TYPE === 'POSITION_DISCOUNT';
			});
			var rate = null;

			if (discount.length === 1 && discount[0].RATE !== 0) rate = '-' + discount[0].RATE + ' %';

			return rate;
		}
	}, {
		key: 'render',
		value: function render() {
			var rate = this.getDiscount();
			// const rate = this.getDiscountRate();

			return _react2.default.createElement(
				_react.Fragment,
				null,
				rate
			);
		}
	}]);

	return ProductDiscount;
}(_react2.default.Component)) || _class2);

var ProductDiscountPercent = exports.ProductDiscountPercent = function (_ProductDiscount) {
	_inherits(ProductDiscountPercent, _ProductDiscount);

	function ProductDiscountPercent(props) {
		_classCallCheck(this, ProductDiscountPercent);

		return _possibleConstructorReturn(this, (ProductDiscountPercent.__proto__ || Object.getPrototypeOf(ProductDiscountPercent)).call(this, props));
	}

	_createClass(ProductDiscountPercent, [{
		key: 'render',
		value: function render() {
			var rate = this.getDiscount();

			return _react2.default.createElement(
				_react.Fragment,
				null,
				rate
			);
		}
	}]);

	return ProductDiscountPercent;
}(ProductDiscount);